import React from 'react';
import "./onboard-button-style.scss";

const OnboardButton = (props) => {

    const {onClick, outline, black, label, blue, gray, outlineBlack} = props;

    return (
        <button onClick={() => onClick()} className={"onboard-button " + (outline ? 'outline ' : ' ')
            + (blue ? 'outline blue ' : ' ') + (black ? 'black ' : ' ') + (gray ? 'outline gray ' : ' ') + (outlineBlack ? 'outline-black ' : ' ')}>{label}
        </button>
    )
};

export default OnboardButton;
